"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Ansichten-Vorschau-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCViews
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCViews} options.module Modulinstanz
 */
gc.gis.module.GCViews.PreviewPanel = function( options )
{
    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCViews);

    this.module = options.module;

    this._initWidgets();

    const options_widget = {
        className: 'gc-views',
        actionbar: new gc.gis.widget.GCMenu({
            containerClassName: 'actionbar',
            items: [
                this._widget_load,
                this._widget_default,
                this._widget_delete
            ]
        })
    };
    gc.gis.widget.GCPanel.call(this, options_widget);

    this.element = this._render();

    this._initContent();
    this._initEvents();
};
gc.gis.module.GCViews.PreviewPanel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

gc.gis.module.GCViews.PreviewPanel.prototype._initWidgets = function()
{
    const self = this;

    this._widget_load = new gc.gis.widget.GCItem({
        label: 'Laden',
        tooltip: 'Lädt die Ansicht',
        className: 'btn btn-success',
        icon: 'action-apply',
        click: function (evt) {
            gc.gis.iface.setView(self.module.getSelectedView());
            gc.gis.iface.ui.sidebar.historyBack();
        }
    });
    this._widget_default = new gc.gis.widget.GCToggleItem({
        active: false,
        label: 'Meine Startansicht',
        tooltip: 'Ansicht als eigene Startansicht verwenden',
        className: 'btn btn-primary',
        icon: 'action-set-default',
        click: function (evt) {
            self.module.setDefaultView(self.module.getSelectedView());
        }
    });
    this._widget_delete = new gc.gis.widget.GCItem({
        label: 'Löschen',
        tooltip: 'Löscht die Ansicht',
        className: 'btn btn-danger',
        icon: 'action-delete',
        click: function (evt) {
            self.module.deleteView(self.module.getSelectedView());
        }
    });
};

/**
 * @protected
 */
gc.gis.module.GCViews.PreviewPanel.prototype._initEvents = function()
{
    const self = this;
    this.module.on( gc.gis.module.GCViewsEvent.VIEW_SELECTED, this, function(evt) {
        self._onViewSelected(evt.newValue);
    });
    this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, this, function(evt) {
        self._onLoadingStarted(evt);
    });
    this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, this, function(evt) {
        self._onLoadingStopped(evt);
    });
};

/**
 * @protected
 */
gc.gis.module.GCViews.PreviewPanel.prototype._initContent = function()
{
    // Titel
    this.element_preview_title = jQuery('<div>', {
        'class': 'gc-views-preview-title',
        html: '<strong>Keine Ansicht gewählt.</strong>'
    });

    // Vorschaubild
    this.element_preview_image = jQuery('<div>', {
        'class': 'gc-views-preview-image',
        html: '<p><em>Keine Ansicht gewählt.</em></p>'
    });

    // Metadaten
    this.element_preview_info_content = jQuery('<ul>', {
        'class': 'gc-list-key-value'
    });
    this.element_preview_info = jQuery('<div>', {
        'class': 'gc-views-preview-info'/*,
         html: '<strong>Info</strong> '*/
    });
    this.element_preview_info.append(this.element_preview_info_content);

    // Container
    const element_preview = jQuery('<div>', {
        'class': 'gc-views-preview'
    });
    element_preview
        .append(this.element_preview_title)
        .append(this.element_preview_image)
        .append(this.element_preview_info);

    this.element_content.append(element_preview);

    this.element_loading = jQuery('<div>', {
        'class': 'gc-views-loading'
    });
    this.element_content.append(this.element_loading);
};

/**
 * @protected
 * @param {Object<string,*>} [view=undefined] Ansicht
 */
gc.gis.module.GCViews.PreviewPanel.prototype._loadPreview = function(view )
{
    if (view)
    {
        // Titel
        this.element_preview_title.html('<strong>' + view.name + '</strong>');

        // Vorschaubild
        if (view.previewUrl)
        {
            this.element_preview_image.children().remove();
            this.element_preview_image.append(jQuery('<img>', {
                src: view.previewUrl,
                alt: 'Vorschaubild'
            }));
        }
        else
        {
            this.element_preview_image.html('<p><em>Kein Vorschaubild vorhanden.</em></p>');
        }

        // Infos
        this.element_preview_info_content.children().remove();
        this.element_preview_info_content.append(jQuery('<li>', {
            'class': 'gc-entry',
            html: '<span class="gc-key">Eigentümer:</span> '
            +'<span class="gc-value">' + view.owner +'</span>'
        }));
        if (view.description)
        {
	        this.element_preview_info_content.append( jQuery('<li>', {
		        'class': 'gc-entry',
		        html: '<span class="gc-key">Beschreibung:</span> '
		        +'<span class="gc-value">' + view.description +'</span>'
	        }));
        }
        this.module._content_preview.setLabel('Ansicht: ' + view.name);
    }
    else
    {
        this.element_preview_image.html('<p><em>Keine Ansicht gewählt.</em></p>');
        this.module._content_preview.setLabel('Ansicht / Vorschau');
    }
};

/**
 * @protected
 * @param {Object<string,*>} view
 */
gc.gis.module.GCViews.PreviewPanel.prototype._onViewSelected = function(view )
{
    this._loadPreview(view);

    if (view)
    {
        this._widget_load.setEnabled( true );
        this._widget_default.setEnabled(true);

        // Löschen-Button aktualisieren
        if (view.states && view.states.readwrite)
        {
            this._widget_delete.setEnabled(true);
        }
        else
        {
            this._widget_delete.setEnabled(false);
        }

        // Startansicht-Button aktualisieren
        if (view.states && view.states.default)
        {
            this._widget_default.setActive(true);
            this._widget_default.setTooltip('Klicken, um Ansicht nicht mehr als eigene Startansicht zu verwenden');
        }
        else
        {
            this._widget_default.setActive(false);
            this._widget_default.setTooltip('Klicken, um Ansicht als eigene Startansicht zu verwenden')
        }
    }
    else
    {
        this._widget_load.setEnabled(false);
        this._widget_default.setEnabled(false);
        this._widget_default.setActive(false);
        this._widget_delete.setEnabled(false);
    }
};

/**
 * @protected
 */
gc.gis.module.GCViews.PreviewPanel.prototype._onLoadingStarted = function()
{
    if (this.loading_queue === 0)
    {
        this.element_loading.show('fade');
    }
    this.loading_queue++;
};

/**
 * @protected
 */
gc.gis.module.GCViews.PreviewPanel.prototype._onLoadingStopped = function()
{
    this.loading_queue--;

    if (this.loading_queue === 0)
    {
        this.element_loading.hide('fade');
    }
};
